import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './authComponents/Login';
import Signup from './authComponents/Signup';
import PasswordReset from './authComponents/PasswordReset';
import MainGame from './components/MainGame';
import AdminPage from './components/AdminPage';

const isAuthenticated = (): boolean => {
  return Boolean(localStorage.getItem('access_token'));
};

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainGame />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
